import { ModuleFE_BaseSandboxModule } from '../ModuleFE_BaseSandboxModule.js';
import { AllNLPMessageTemplates } from './templates.js';
import { ModuleFE_Advisor_AdvisorSnippet } from '../../../../modules/static-modules/advisor-context.js';
import { ModuleFE_Advisor_ContextRule } from '../../../../modules/static-modules/healthcare-space.js';
class ModuleFE_SandboxNLP_Class extends ModuleFE_BaseSandboxModule {
    constructor() {
        super('storage-nlp', AllNLPMessageTemplates);
    }
    async listTemplates() {
        return ModuleFE_Advisor_AdvisorSnippet.cache.all().map(snippet => {
            const contextRules = ModuleFE_Advisor_ContextRule.cache.unique(snippet.contextRuleId);
            return { label: snippet.label, content: { rules: contextRules?.rules } };
        });
    }
}
export const ModuleFE_SandboxNLP = new ModuleFE_SandboxNLP_Class();
//# sourceMappingURL=ModuleFE_SandboxNLP.js.map